import { FormSection } from '../../../../forms/FormSection'
import { InformationForm } from '../forms/InformationForm'

export const GeneralParams = () => {
  return (
    <FormSection number={1} sectionTitle="Obecné informace">
      <InformationForm />
    </FormSection>
  )
}
